export enum RateType {
  like = 'like',
  dislike = 'dislike',
}

export enum PaymentErrorTypes {
  success = 'success',
  failure = 'failure',
}
